/**
 * sgpCacheTabStyles.js — StyleSheet for SGPCacheTab.
 * Extracted verbatim from components/SGPCacheTab.jsx (god-file decomposition).
 */

import { StyleSheet } from 'react-native';
import { uiVar } from './floodlight/uiStyleCss';
import { ADM_DISPLAY } from './floodlight/vars/admin';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: uiVar('adm-card', '#111827'),
  },
  contentContainer: {
    padding: 16,
  },
  header: {
    marginBottom: 16,
  },
  headerTitle: { ...ADM_DISPLAY, letterSpacing: uiVar('adm-display-track', 'normal'),
    fontSize: 20,
    fontWeight: 'bold',
    color: uiVar('adm-ink', '#E5E7EB'),
    marginBottom: 4,
  },
  headerSubtitle: {
    fontSize: 13,
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  searchContainer: {
    marginBottom: 12,
  },
  searchInput: {
    height: 40,
    backgroundColor: uiVar('adm-card', '#1F2937'),
    borderRadius: 8,
    paddingHorizontal: 12,
    fontSize: 14,
    color: uiVar('adm-ink', '#E5E7EB'),
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  leagueFilterContainer: {
    marginBottom: 16,
    backgroundColor: uiVar('adm-card', '#1F2937'),
    borderRadius: 10,
    padding: 12,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  sportCategoriesRow: {
    marginBottom: 10,
  },
  sportCategoriesContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  filterSectionLabel: {
    fontSize: 11,
    fontWeight: '600',
    color: uiVar('adm-muted2', '#6B7280'),
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  sportCategoryButton: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: uiVar('adm-card', '#111827'),
    borderRadius: 8,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  sportCategoryButtonActive: {
    backgroundColor: uiVar('adm-accent-wash-20', 'rgba(139, 92, 246, 0.2)'),
    borderColor: uiVar('adm-accent', '#8B5CF6'),
  },
  sportCategoryButtonPartial: {
    backgroundColor: 'rgba(245, 158, 11, 0.1)',
    borderColor: '#F59E0B',
  },
  sportCategoryText: {
    fontSize: 12,
    fontWeight: '500',
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  sportCategoryTextActive: {
    color: uiVar('adm-accent', '#A78BFA'),
    fontWeight: '600',
  },
  sportCategoryTextPartial: {
    color: '#FBBF24',
    fontWeight: '600',
  },
  leagueTogglesRow: {
    marginBottom: 8,
  },
  leagueFilterContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  leagueButton: {
    paddingVertical: 5,
    paddingHorizontal: 10,
    backgroundColor: uiVar('adm-card', '#111827'),
    borderRadius: 16,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  leagueButtonActive: {
    backgroundColor: 'rgba(16, 185, 129, 0.15)',
    borderColor: '#10B981',
  },
  leagueButtonText: {
    fontSize: 11,
    fontWeight: '500',
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  leagueButtonTextActive: {
    color: '#10B981',
    fontWeight: '600',
  },
  filterQuickActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  filterActiveText: {
    fontSize: 11,
    color: uiVar('adm-muted2', '#6B7280'),
  },
  filterClearText: {
    fontSize: 11,
    color: '#3B82F6',
    fontWeight: '600',
  },
  actionButtonsContainer: {
    flexDirection: 'row',
    marginBottom: 16,
    gap: 8,
  },
  actionButton: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 42,
  },
  fetchButton: {
    backgroundColor: '#3B82F6',
  },
  generateAllButton: {
    backgroundColor: '#10B981',
  },
  actionButtonText: {
    color: uiVar('adm-ink', '#FFFFFF'),
    fontSize: 13,
    fontWeight: '600',
  },
  loadingContainer: {
    padding: 30,
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 10,
    fontSize: 14,
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  fixturesContainer: {
    flex: 1,
  },
  resultsCount: {
    fontSize: 12,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 12,
    fontWeight: '600',
  },
  // ⭐ Date Group Section Styles
  dateGroupContainer: {
    marginBottom: 16,
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: uiVar('adm-card', '#1F2937'),
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  sectionHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    flexWrap: 'wrap',
    gap: 8,
  },
  sectionEmoji: {
    fontSize: 18,
  },
  sectionTitle: { ...ADM_DISPLAY, letterSpacing: uiVar('adm-display-track', 'normal'),
    fontSize: 16,
    fontWeight: '700',
    color: uiVar('adm-ink', '#E5E7EB'),
  },
  sectionBadge: {
    backgroundColor: uiVar('adm-raised', '#374151'),
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 12,
  },
  sectionBadgeCached: {
    backgroundColor: '#065F46',
  },
  sectionBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  sectionHeaderRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  sectionLeagues: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    flexWrap: 'wrap',
    maxWidth: 300,
  },
  sectionLeagueBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: uiVar('adm-raised', '#374151'),
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderRadius: 4,
    gap: 4,
  },
  sectionLeagueText: {
    fontSize: 10,
    fontWeight: '600',
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  sectionLeagueCount: {
    fontSize: 9,
    fontWeight: '700',
    color: uiVar('adm-muted2', '#6B7280'),
    backgroundColor: uiVar('adm-card', '#1F2937'),
    paddingHorizontal: 4,
    paddingVertical: 1,
    borderRadius: 3,
  },
  sectionLeagueMore: {
    fontSize: 10,
    color: uiVar('adm-muted2', '#6B7280'),
    fontStyle: 'italic',
  },
  sectionExpandIcon: {
    fontSize: 14,
    color: '#3B82F6',
    fontWeight: 'bold',
  },
  fixtureCard: {
    backgroundColor: uiVar('adm-card', '#1F2937'),
    borderRadius: 8,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
    overflow: 'hidden',
  },
  fixtureHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 12,
  },
  fixtureHeaderLeft: {
    flex: 1,
  },
  fixtureHeaderTop: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  fixtureLeague: {
    fontSize: 10,
    fontWeight: '700',
    color: '#3B82F6',
    marginRight: 8,
    textTransform: 'uppercase',
  },
  statusBadge: {
    marginRight: 8,
  },
  statusFlag: {
    fontSize: 10,
  },
  cachedBadge: {
    backgroundColor: '#065F46',
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderRadius: 4,
  },
  cachedBadgeText: {
    fontSize: 9,
    color: '#10B981',
    fontWeight: '600',
  },
  fixtureTeams: {
    fontSize: 14,
    fontWeight: '600',
    color: uiVar('adm-ink', '#E5E7EB'),
    marginBottom: 4,
  },
  fixtureDate: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 2,
  },
  fixtureStatsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  fixtureStats: {
    fontSize: 10,
    color: uiVar('adm-muted2', '#6B7280'),
  },
  sgpReadyBadge: {
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderRadius: 4,
  },
  sgpReadyBadgeGood: {
    backgroundColor: '#065F46',
  },
  sgpReadyBadgeWarn: {
    backgroundColor: '#92400E',
  },
  sgpReadyBadgeText: {
    fontSize: 9,
    fontWeight: '600',
  },
  fixtureHeaderRight: {
    alignItems: 'flex-end',
  },
  generateButton: {
    backgroundColor: '#3B82F6',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 6,
    marginBottom: 8,
    minWidth: 90,
    alignItems: 'center',
  },
  generateButtonText: {
    color: uiVar('adm-ink', '#FFFFFF'),
    fontSize: 11,
    fontWeight: '600',
  },
  expandIcon: {
    fontSize: 12,
    color: '#3B82F6',
    fontWeight: 'bold',
  },
  logContainer: {
    backgroundColor: uiVar('adm-card', '#111827'),
    padding: 10,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  logText: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    fontFamily: 'Courier',
  },
  sgpsContainer: {
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
    padding: 12,
  },
  legCountSection: {
    marginBottom: 16,
  },
  legCountHeader: {
    fontSize: 14,
    fontWeight: '700',
    color: uiVar('adm-ink', '#E5E7EB'),
    marginBottom: 8,
  },
  sgpCard: {
    backgroundColor: uiVar('adm-card', '#111827'),
    borderRadius: 6,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
    overflow: 'hidden',
  },
  sgpHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
  },
  sgpHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  sgpRank: {
    fontSize: 16,
    fontWeight: '700',
    color: '#3B82F6',
    marginRight: 12,
  },
  sgpOdds: {
    fontSize: 16,
    fontWeight: '700',
    color: '#10B981',
  },
  sgpBook: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  sgpHeaderRight: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  evBadge: {
    backgroundColor: uiVar('adm-card', '#1F2937'),
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 4,
    marginRight: 8,
  },
  evBadgePositive: {
    backgroundColor: '#065F46',
  },
  evBadgeText: {
    fontSize: 11,
    fontWeight: '600',
    color: '#10B981',
  },
  legsContainer: {
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
    padding: 10,
  },
  baselineRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: uiVar('adm-hair', '#374151'),
  },
  baselineLabel: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginRight: 8,
  },
  baselineValue: {
    fontSize: 12,
    color: uiVar('adm-ink', '#E5E7EB'),
    fontWeight: '600',
  },
  legRow: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  legNumber: {
    fontSize: 11,
    fontWeight: '700',
    color: '#3B82F6',
    width: 40,
  },
  legDetails: {
    flex: 1,
  },
  legMarket: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 2,
  },
  legSelection: {
    fontSize: 12,
    fontWeight: '600',
    color: uiVar('adm-ink', '#E5E7EB'),
  },
  legPrice: {
    fontSize: 10,
    color: '#10B981',
    marginTop: 2,
  },
  allBooksContainer: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  allBooksHeader: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 4,
    fontWeight: '600',
  },
  bookRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 4,
  },
  bookName: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
    flex: 1,
  },
  bookPriceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  bookPrice: {
    fontSize: 10,
    color: uiVar('adm-ink', '#E5E7EB'),
    fontWeight: '600',
  },
  bookEV: {
    fontSize: 9,
    fontWeight: '500',
  },
  bookEVPositive: {
    color: '#10B981',
  },
  bookEVNegative: {
    color: '#EF4444',
  },
  moreText: {
    fontSize: 11,
    color: uiVar('adm-muted2', '#6B7280'),
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: 8,
  },
  generatedAt: {
    fontSize: 10,
    color: uiVar('adm-muted2', '#6B7280'),
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: 12,
  },
  noCacheContainer: {
    padding: 20,
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  noCacheText: {
    fontSize: 13,
    color: uiVar('adm-muted', '#9CA3AF'),
    textAlign: 'center',
  },
  aiDataContainer: {
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    borderRadius: 6,
    padding: 8,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: 'rgba(59, 130, 246, 0.3)',
  },
  aiDataRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 2,
  },
  aiDataLabel: {
    fontSize: 10,
    color: '#93C5FD',
    fontWeight: '600',
  },
  aiDataValue: {
    fontSize: 10,
    color: uiVar('adm-ink', '#E5E7EB'),
    fontWeight: '700',
  },
  statsContainer: {
    backgroundColor: 'rgba(16, 185, 129, 0.1)',
    borderRadius: 8,
    padding: 12,
    marginTop: 12,
    borderWidth: 1,
    borderColor: 'rgba(16, 185, 129, 0.3)',
  },
  statsHeader: {
    fontSize: 12,
    color: '#10B981',
    fontWeight: '700',
    marginBottom: 8,
  },
  statsGrid: {
    gap: 6,
  },
  statItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 3,
  },
  statLabel: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  statValue: {
    fontSize: 11,
    color: uiVar('adm-ink', '#E5E7EB'),
    fontWeight: '700',
  },
  // Combo counts styles
  comboCountsRow: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  comboCountsLabel: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 6,
    fontWeight: '600',
  },
  comboCountsValues: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  comboCountBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: uiVar('adm-card', '#1F2937'),
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 6,
    marginRight: 8,
    marginBottom: 4,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  comboCountLabel: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginRight: 4,
  },
  comboCountValue: {
    fontSize: 12,
    fontWeight: '700',
    color: '#10B981',
  },
  comboCountsHint: {
    fontSize: 10,
    color: uiVar('adm-muted2', '#6B7280'),
    fontStyle: 'italic',
  },
  // ⭐ Timer & Stats Card Styles
  timerCard: {
    backgroundColor: uiVar('adm-card', '#1F2937'),
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: uiVar('adm-hair', '#374151'),
  },
  timerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  timerSection: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  timerLabel: {
    fontSize: 12,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 4,
    fontWeight: '600',
  },
  timerValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: uiVar('adm-accent', '#8B5CF6'),
    fontVariant: ['tabular-nums'],
  },
  timerSubtext: {
    fontSize: 10,
    color: uiVar('adm-muted2', '#6B7280'),
    marginTop: 2,
  },
  cacheStatsSummary: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  cacheStatItem: {
    alignItems: 'center',
  },
  cacheStatValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: uiVar('adm-ink', '#E5E7EB'),
  },
  cacheStatLabel: {
    fontSize: 10,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginTop: 2,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  leagueBreakdown: {
    marginTop: 16,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: uiVar('adm-hair', '#374151'),
  },
  leagueBreakdownTitle: {
    fontSize: 11,
    color: uiVar('adm-muted', '#9CA3AF'),
    marginBottom: 8,
    fontWeight: '600',
  },
  leagueBreakdownRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  leagueBreakdownItem: {
    backgroundColor: uiVar('adm-card', '#111827'),
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 6,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  leagueBreakdownLeague: {
    fontSize: 10,
    fontWeight: '700',
    color: '#3B82F6',
  },
  leagueBreakdownCount: {
    fontSize: 12,
    fontWeight: '700',
    color: '#10B981',
  },
  // Bulk progress styles
  progressContainer: {
    backgroundColor: uiVar('adm-card', '#1F2937'),
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: '#3B82F6',
  },
  progressHeader: {
    marginBottom: 12,
  },
  progressTitle: {
    fontSize: 14,
    fontWeight: '700',
    color: uiVar('adm-ink', '#E5E7EB'),
    marginBottom: 4,
  },
  progressStats: {
    fontSize: 12,
    color: uiVar('adm-muted', '#9CA3AF'),
  },
  progressBarContainer: {
    height: 24,
    backgroundColor: uiVar('adm-raised', '#374151'),
    borderRadius: 12,
    overflow: 'hidden',
    marginBottom: 8,
  },
  progressBarFill: {
    height: '100%',
    backgroundColor: '#10B981',
    borderRadius: 12,
    transition: 'width 0.3s ease',
  },
  progressPercent: {
    fontSize: 16,
    fontWeight: '700',
    color: '#10B981',
    textAlign: 'center',
  },
  currentFixture: {
    fontSize: 13,
    color: uiVar('adm-accent', '#a259ff'),
    textAlign: 'center',
    marginBottom: 8,
    fontWeight: '500',
  },
  estimatedTime: {
    fontSize: 12,
    color: uiVar('adm-muted', '#9CA3AF'),
    textAlign: 'center',
    marginTop: 6,
  },
});
